import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { toast } from "sonner";

const WishlistContext = createContext();
const STORAGE_KEY = "ie_wishlist_v1";

export function WishlistProvider({ children }) {
  const [ids, setIds] = useState(() => {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]"); }
    catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
  }, [ids]);

  const toggle = useCallback((product) => {
    setIds((prev) => {
      if (prev.includes(product.id)) {
        toast("Removed from wishlist");
        return prev.filter((p) => p !== product.id);
      }
      toast.success("Added to wishlist", { description: product.name });
      return [...prev, product.id];
    });
  }, []);

  const has = useCallback((id) => ids.includes(id), [ids]);

  return (
    <WishlistContext.Provider value={{ ids, toggle, has, count: ids.length }}>
      {children}
    </WishlistContext.Provider>
  );
}

export const useWishlist = () => useContext(WishlistContext);
